module.exports = __webpack_public_path__ + "img/welcome-background-box-large.78d7b5fd.svg";